import { motion } from "framer-motion";

export const fadeUp = {
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

export function Reveal({ children, delay = 0, className = "", ...rest }) {
  return (
    <motion.div className={className} {...fadeUp} transition={{ ...fadeUp.transition, delay }} {...rest}>
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for display headlines
export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span className="line-mask" key={i}>
          <motion.span
            className={lineClassName}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
